export const formatNumber = (num: string | number) => {
  if (typeof num === 'string')
    return Intl.NumberFormat('en-US').format(Number(num));
  return Intl.NumberFormat('en-US').format(num);
};

export const formatNumberMoney = (num: string | number, maximumFractionDigits: number = 2) => {
  if (typeof num === 'string')
    return Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits,
    }).format(Number(num));
  return Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits,
  }).format(num);
};

export const formatNumberPercentage = (num: string | number) => {
  let number = typeof num === 'string' ? Number(num) : num;
  number = number / 100;
  return Intl.NumberFormat('en-US', {
    style: 'percent',
    maximumFractionDigits: 2,
  }).format(number);
};
